import React, { FC } from 'react'
import styled from 'styled-components'

import { useGetCustomerOrders } from '../../../../lib/orders/hooks/useGetCustomerOrders'
import { isNotNull } from '../../../../utils/collectionTools'
import Link from '../../../global/Link'
import Spinner from '../../../Spinner'
import EmptyHistory from '../EmptyHistory'
import { CustomerOrdersTable } from '../orders/table'

export const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.component.link};
`

const RecentOrdersContainer: FC = () => {
  const { data, loading } = useGetCustomerOrders()
  const orders = (data?.getCustomerOrders?.orders || []).filter(isNotNull)

  if (loading) {
    return <Spinner loading />
  }

  return (
    <>
      <header className="most-recent-orders">
        <h3>Most Recent Orders</h3>
        <StyledLink to="/account/orders">View all orders</StyledLink>
      </header>
      {orders.length ? (
        <CustomerOrdersTable orders={orders} urlFragment="orders" />
      ) : (
        <EmptyHistory message="No order history at the moment." />
      )}
    </>
  )
}

export default RecentOrdersContainer
